'use client';

import Image from 'next/image';

type Props = {
  showLastLogin?: boolean;
  onLogin: () => void;
  disabled: boolean;
  isLoginPending: boolean;
};

export const LineLoginButton = ({ showLastLogin, onLogin, disabled, isLoginPending }: Props) => {
  return (
    <button
      type="button"
      onClick={onLogin}
      disabled={disabled}
      aria-busy={isLoginPending}
      className={
        'flex items-center relative w-full px-6 py-4 bg-[#00B900] text-white rounded-[6px] hover:opacity-90 transition-opacity disabled:cursor-not-allowed disabled:opacity-50'
      }
    >
      <div className="absolute left-6 w-6 h-6">
        <Image src="/icons/line-icon.svg" alt="LINE" width={24} height={24} className="w-full h-full object-contain" />
      </div>
      <div className="flex flex-col items-center w-full">
        <span className="text-[16px] font-semibold">{isLoginPending ? 'LINEに接続中…' : 'LINEで続ける'}</span>
        {showLastLogin && <span className="text-[12px] font-semibold leading-[13px]">前回ログイン</span>}
      </div>
    </button>
  );
};
